import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './index.css'
import App from './App.vue'

const app = createApp(App)
const pinia = createPinia()

app
  .use(pinia)
  .mount('#webmoose-order-form')
